export function getCookie(name) {
	let nameEq = `${name}=`;
	let cookies = document.cookie.split(';').map(e => e.trim());

	for (let cookie of cookies) {
		if (cookie.startsWith(nameEq)) {
			return cookie.slice(nameEq.length);
		}
	}
	return null;
}

export function setCookie(name, value, days) {
	let expiry;
	if (+days) {
		expiry = (new Date(Date.now() + (days * 24 * 3600 * 1000))).toUTCString();
	}

	let parts = [
		[name, value],
		expiry && ['expires', expiry],
		['path', '/']
	];
	document.cookie = parts.filter(e => e).map(part => part.join('=')).join('; ');
}
